import React from 'react';
import { CheckCircle2Icon, XOctagonIcon } from 'lucide-react';
export function WhoIsFor() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-195">
          {/* Who is FOR */}
          <div className="bg-brand-card border border-brand-green/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-196">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-197" />

            <h3 className="text-3xl text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-198">
              <CheckCircle2Icon className="w-8 h-8 text-brand-green" data-id="element-199" />
              ESTO ES PARA TI SI:
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-200">
              {['Estás cansado de perder dinero siguiendo picks que no entiendes.', 'Quieres convertir las apuestas en un sistema, no en suerte.', 'Buscas independencia total y dejar de depender de "expertos".'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-201">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-202" />
                  <span className="text-lg text-brand-muted" data-id="element-203">{text}</span>
                </li>)}
            </ul>
          </div>

          {/* Who is NOT FOR */}
          <div className="bg-brand-card border border-brand-red/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-204">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-205" />

            <h3 className="text-3xl text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-206">
              <XOctagonIcon className="w-8 h-8 text-brand-red" data-id="element-207" />
              ESTO NO ES PARA TI SI:
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-208">
              {['Buscas dinero rápido sin pensar ni analizar.', 'Necesitas que alguien te diga exactamente qué apostar.', 'Crees en "fijas", grupos VIP o resultados amañados.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-209">
                  <XOctagonIcon className="w-6 h-6 text-brand-red shrink-0 mt-0.5" data-id="element-210" />
                  <span className="text-lg text-brand-muted" data-id="element-211">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="mt-12 text-center" data-id="element-212">
          <p className="text-2xl md:text-3xl text-brand-gold font-bold" data-id="element-213">
            Este sistema está diseñado para personas que quieren control, no
            excusas.
          </p>
        </div>
      </div>
    </section>;
}